import { a as setMode } from './index-8f697f19.js';
setMode(elm => {
  // NOTE: you can write whatever you want here - it's up to you. This
  // function must return one of the style "modes" defined in step 1.
  return elm.mode || elm.getAttribute('mode') || 'default';
});